/* eslint-disable */
import { getDataSource, getMe } from 'legacy/store/appReducer';
import { DATASOURCES } from 'legacy/constants';
import { notification } from 'antd';

// URL functions
import {
  idtfPatientRevoke,
  idtfPatientEarlyTermination,
} from 'legacy/containers/ApiUrls';

// Constants Types
// ET - Early terminate
import {
  PATIENT_REVOKE_REQUEST,
  PATIENT_REVOKE_SUCCESS,
  PATIENT_REVOKE_FAILURE,
  PATIENT_ET_REQUEST,
  PATIENT_ET_SUCCESS,
  PATIENT_ET_FAILURE,
} from './types';

// ------------------------------------
// Actions
// ------------------------------------

export const patientRevokeRequest = () => ({
  type: PATIENT_REVOKE_REQUEST,
});
export const patientRevokeSuccess = data => ({
  type: PATIENT_REVOKE_SUCCESS,
  payload: data,
});
export const patientRevokeFailure = err => ({
  type: PATIENT_REVOKE_FAILURE,
  payload: err,
});

export const patientEarlyTerminateRequest = () => ({
  type: PATIENT_ET_REQUEST,
});
export const patientEarlyTerminateSuccess = data => ({
  type: PATIENT_ET_SUCCESS,
  payload: data,
});
export const patientEarlyTerminateFailure = err => ({
  type: PATIENT_ET_FAILURE,
  payload: err,
});

// Terminate the IDTF Connection when Patient has Code generated / connected, but no recording is taken 
export const handlePatientRevoke = (idtfConnectionId) => (
  dispatch,
  getState,
) => {
  dispatch(patientRevokeRequest());
  const meDataSource = getDataSource(getState(), DATASOURCES.ME);
  let promises;

  if (meDataSource.data) {
    promises = Promise.resolve();
  } else {
    promises = dispatch(getMe());
  }

  return promises
  .then(() => {
    return Promise.all([
      dispatch(idtfPatientRevoke(idtfConnectionId)),
    ]);
  })
    // .then((res) => {
    //       notification['success']({
    //         message: `Revoke Success`,
    //         description: 'Successfully Revoked',
    //       });
    //   })
    .then(data => {
      if (data[0].errors) {
        dispatch(patientRevokeFailure(data[0].errors));
        notification['error']({
          message: data[0].errors[0].title,
          description: data[0].errors[0].detail,
        });
      } else {
        dispatch(patientRevokeSuccess(data[0].message))
        notification['success']({
          message: data[0].message,
        });
      }
    })
  // .then(data => {
  //   return dispatch(patientRevokeSuccess(data)),
  //   notification['success']({
  //     message: `Revoke Success`,
  //     description: 'Successfully Revoked',
  //   });
  // })
    .catch(err => {
      return dispatch(patientRevokeFailure(err)),
      notification['error']({
        message: `Error!`,
        description: 'Something went wrong.',
      });
    });
};

// Early Terminate the IDTF active connection 
export const handlePatientEarlyTerminate = (idtfConnectionId) => (
  dispatch,
  getState,
) => {
  dispatch(patientEarlyTerminateRequest());
  const meDataSource = getDataSource(getState(), DATASOURCES.ME);
  let promises;

  if (meDataSource.data) {
    promises = Promise.resolve();
  } else {
    promises = dispatch(getMe());
  }

  return promises
  .then(() => {
    return Promise.all([
      dispatch(idtfPatientEarlyTermination(idtfConnectionId)),
    ]);
  })

  .then(data => {
    if (data[0].errors) {
      dispatch(patientEarlyTerminateFailure(data[0].errors));
      notification['error']({
        message: data[0].errors[0].title,
        description: data[0].errors[0].detail,
      });
    } else {
      dispatch(patientEarlyTerminateSuccess(data[0].message))
      notification['success']({
        message: data[0].message,
      });
    }
  })
    .catch(err => {
      return dispatch(patientEarlyTerminateFailure(err)),
      notification['error']({
        message: `Error!`,
        description: 'Something went wrong.',
      });
    });
};




// WEBPACK FOOTER //
// ./src/views/state/IdtfRevokeET/IdtfRevokeETActions.js